module.exports = {
    webName:"海南西度教育科技有限公司",
    webNm:"海南西度教育科技有限公司",
    webTel:"15867131819",
    webNo:"琼ICP备2026000721号",
    webAddress:"海南省海口市美兰区海府街道龙昆南路华新商业大厦B504号房",
    goods:[
        {'value':61,'name':'学生文具供应'},
        {'value':62,'name':'财会用品供应'},
        // {'value':63,'name':'办公文具供应'},
        // {'value':64,'name':'文件管理供应'},
        {'value':65,'name':'本册便签供应'},
        // {'value':66,'name':'画具画材供应'},
        // {'value':67,'name':'笔袋文具盒供应'},
        // {'value':68,'name':'标签贴纸供应'},
    ],
    webColor:'#d4eff8',//蓝色#d4eff8,绿色#d4f8ec,黄色#ecf7dc,粉色#f8e8f9,红色#f9eae8
    webBg:'',
  }

  